import { useEffect, useState } from "react";

// Este hook almacena las dimensiones de la pantalla visible en el dispositivo del usuario
// Estos valores se actualizan cada vez que la pantalla se redimensiona (mediante el resize event listener)
const useViewSize = () => {
  const [viewSize, setViewSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const changeViewSize = () => {
    setViewSize({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener("resize", changeViewSize);

    return () => {
      window.removeEventListener("resize", changeViewSize);
    };
  }, []);

  return viewSize;
};

export default useViewSize;
